!function (e, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n(require("./foundation.core"), require("jquery")) : "function" == typeof define && define.amd ? define(["./foundation.core", "jquery"], n) : "object" == typeof exports ? exports["foundation.util.nest"] = n(require("./foundation.core"), require("jquery")) : (e.__FOUNDATION_EXTERNAL__ = e.__FOUNDATION_EXTERNAL__ || {}, e.__FOUNDATION_EXTERNAL__["foundation.util.nest"] = n(e.__FOUNDATION_EXTERNAL__["foundation.core"], e.jQuery));
}(window, function (t, r) {
  return u = {
    "./foundation.core": function (e, n) {
      e.exports = t;
    },
    "./js/entries/plugins/foundation.util.nest.js": function (e, n, t) {
      "use strict";

      t.r(n);
      var r = t("./foundation.core");
      t.d(n, "Foundation", function () {
        return r.Foundation;
      });
      var o = t("./js/foundation.util.nest.js");
      t.d(n, "Nest", function () {
        return o.Nest;
      }), r.Foundation.Nest = o.Nest;
    },
    "./js/foundation.util.nest.js": function (e, n, t) {
      "use strict";

      t.r(n), t.d(n, "Nest", function () {
        return r;
      });
      var n = t("jquery"),
          a = t.n(n),
          r = {
        Feather: function (e) {
          var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "zf";
          e.attr("role", "menubar"), e.find("a").attr({
            role: "menuitem"
          });
          var e = e.find("li").attr({
            role: "none"
          }),
              r = "is-".concat(t, "-submenu"),
              o = "".concat(r, "-item"),
              u = "is-".concat(t, "-submenu-parent"),
              i = "accordion" !== t;
          e.each(function () {
            var e = a()(this),
                n = e.children("ul");
            n.length && (e.addClass(u), i && (e.children("a:first").attr({
              "aria-haspopup": !0,
              "aria-label": e.children("a:first").text()
            }), "drilldown" === t && e.attr({
              "aria-expanded": !1
            })), n.addClass("submenu ".concat(r)).attr({
              "data-submenu": "",
              role: "menubar"
            }), "drilldown" === t && n.attr({
              "aria-hidden": !0
            })), e.parent("[data-submenu]").length && e.addClass("is-submenu-item ".concat(o));
          });
        },
        Burn: function (e, n) {
          var t = "is-".concat(n, "-submenu"),
              r = "".concat(t, "-item"),
              n = "is-".concat(n, "-submenu-parent");
          e.find(">li, > li > ul, .menu, .menu > li, [data-submenu] > li").removeClass("".concat(t, " ").concat(r, " ").concat(n, " is-submenu-item submenu is-active")).removeAttr("data-submenu").css("display", "");
        }
      };
    },
    26: function (e, n, t) {
      e.exports = t("./js/entries/plugins/foundation.util.nest.js");
    },
    jquery: function (e, n) {
      e.exports = r;
    }
  }, i = {}, o.m = u, o.c = i, o.d = function (e, n, t) {
    o.o(e, n) || Object.defineProperty(e, n, {
      enumerable: !0,
      get: t
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (n, e) {
    if (1 & e && (n = o(n)), 8 & e) return n;
    if (4 & e && "object" == typeof n && n && n.__esModule) return n;
    var t = Object.create(null);
    if (o.r(t), Object.defineProperty(t, "default", {
      enumerable: !0,
      value: n
    }), 2 & e && "string" != typeof n) for (var r in n) o.d(t, r, function (e) {
      return n[e];
    }.bind(null, r));
    return t;
  }, o.n = function (e) {
    var n = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(n, "a", n), n;
  }, o.o = function (e, n) {
    return Object.prototype.hasOwnProperty.call(e, n);
  }, o.p = "", o(o.s = 26);

  function o(e) {
    if (i[e]) return i[e].exports;
    var n = i[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return u[e].call(n.exports, n, n.exports, o), n.l = !0, n.exports;
  }

  var u, i;
});